// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';

// export const environment = {
//   production: true,
//   version: env['npm_package_version'],
//   serverUrl: 'https://api.chucknorris.io',
//   defaultLanguage: 'en-US',
//   supportedLanguages: ['en-US', 'fr-FR'],
// };

//// keycloakAngularConfig Angular Client Configuration
export const keycloakAngularConfig = {
  dgsUrlKey: 'qav2-portmore',
  clients: {
    default: {
      authority: 'https://training-identity.flecx.io',
      apiBaseUrl: 'https://qav2.flecx.io',
      portalUrl: 'https://qav2.flecx.io',
      realm: 'qa-flecx',
    },
    dgs: {
      authority: 'https://training-identity.flecx.io',
      apiBaseUrl: 'https://qav2-portmore.flecx.io',
      portalUrl: 'https://qav2-portmore.flecx.io',
      realm: 'qa-dgs-flecx',
    },
  },
  clientId: 'angular-client',
  redirectUri: window.location.origin,
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  enableLogging: true,
  checkLoginIframe: false,
  clockSkew: 86400,
};

export const environment = {
  production: true,
  version: env['npm_package_version'] + '-dev',
  appVersion: require('../../package.json').version + '-dev',
  api: {
    //url: window.location.origin.indexOf(keycloakAngularConfig.dgsUrlKey) != -1 ? keycloakAngularConfig.clients.dgs.apiBaseUrl + '/api' : keycloakAngularConfig.clients.default.apiBaseUrl + '/api',
    url: window.location.origin + '/api',
    server: '/api',
    version: '/v1',
  },
  messenger: {
    url: window.location.origin + '/messaging',
    server: '/api',
    version: '/v1',
  },
  telephony: {
    url: window.location.origin + '/voice',
    server: '/api',
    version: '/v1',
  },
  bundleDealerUrl: 'https://qa-webdialer.bundledealer.com/',
  bundleDealerSessionRecall: 'https://qa-webdialer.bundledealer.com/BundleDealer/ConsoleSessionRecall',
  bundleDealerCommercialUrl: 'https://qa.bundledealer.com/CommercialLead/iframe',
  defaultLanguage: 'en-CA',
  hmr: false,
  logs: false,
  reflecxRoutePrefix: 'composer', // admin, '', admin
  reportingRoutePrefix: 'insights', // reporting, reporting, ''
  defaultAppRoute: 'insights', // reporting, datasource, globaldashboard
  Apps: { ReflecxApp: true, ReportingApp: true },
  baseLine: false,
  cacheDb: 'MyApp',
  isPrintAllowed: true,
  printServerUrl: 'http://localhost:3000',
  libraryPath: '/library/',
  FilePath: '/Uploads/',
  directorySeparator: '\\\\',
  fromEmailAddress: ['survey@epanelprogram.toyotaexperience.ca', 'survey@epanelprogram.lexusexperience.ca'],
  dateFormat: 'LLL dd, yyyy, hh:mm:ss aa',
  signalRConfigured: true,
  signalRUrl: window.location.origin + '/realtime/RealTimeNotificationHub',
  loaderStyle: 'main',
  defaultMarketLanguage: 'en-CA',
  NotificationSetting: {
    notificationSessionTimeoutMinutes: 1,
    notificationUpdateInterval: 30000,
  },
  login: {
    isDefaultEnabled: false,
    defaultRoute: '/login/:id',
    defaultRouteValue: 'mbc',
  },
  supportedLanguages: ['en-CA'],
  ping: {
    url: window.location.origin + '/ping/',
    method: 'GET',
    timeout: 5000,
  },
  testNumber: '+12022899898',
};

// IdentityServer Angular Client Configuration
export const identityServerAngularConfig = {
  // authority: 'https://qapd.reflecx.io/accounts',
  authority: 'https://devv2-identity.flecx.io/',
  client_id: 'dev-angular',
  redirect_uri: 'https://devv2.flecx.io/callback.html',
  response_type: 'code',
  scope: 'openid profile email api1 offline_access',
  post_logout_redirect_uri: 'https://devv2.flecx.io/signout-callback',
  silent_redirect_uri: 'https://devv2.flecx.io/silent-callback.html',
  automaticSilentRenew: false,
  accessTokenExpiringNotificationTime: 300,
  clockSkew: 86400,
};

// IdentityServer SSO Configuration
export const identityServerSSOConfig = {
  // authority: 'https://qapd.reflecx.io/accounts',
  // authority: 'https://qapd.reflecx.io/accounts',
  // authority: 'https://qapd.reflecx.io/accounts',
  authority: 'http://localhost:5000',
  client_id: 'external',
  redirect_uri: 'http://localhost:4200/extcallback.html',
  response_type: 'code',
  scope: 'openid profile email api1 offline_access',
  post_logout_redirect_uri: 'http://localhost:4200/logout',
  silent_redirect_uri: 'http://localhost:4200/renew-callback.html',
  accessTokenExpiringNotificationTime: 20,
  automaticSilentRenew: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
export const apiURL = 'https://inteliq.io/vocdemoapi';
export const staticUrl = 'https://clearviewprodemo.com';
export const QNAAPIURL = 'http://172.21.3.198:8015/qa_service/';
export const pipelineData = {
  Comment_Type: 'social_media',
  TopNCategories: '3',
  ModelFilesPath: '/data/E_Drive/All_Models/cross_lingual_models',
  BatchSizetoProcess: '1000',
  ClientCode: 'Acura',
  IS_DEBUG: 'False',
  Client_Name_Masking: 'Toyota',
};
